const AI_CALL_RESULTS = {
  ALREADY_SCHEDULED: {api_name: 'logalreadyscheduled', display: 'INSP Scheduled', value: 'logalreadyscheduled', showOrder: 0, def: false},
  RESCHEDULED: {api_name: 'rescheduled', display: 'Call Later', value: 'rescheduled', showOrder: 1, def: false},
  CALL_YOU_BACK: {api_name: 'callyouback', display: 'HO Will Call iPermit', value: 'callyouback', showOrder: 2, def: false},
  WRONG_NUMBER: {api_name: 'wrongnumber', display: 'Update Phone', value: 'wrongnumber', showOrder: 3, def: false},
  HANGUP: {api_name: 'hangup', display: 'Hung Up', value: 'hangup', showOrder: 4, def: false},
  NO_ANSWER: {api_name: 'noanswer', display: 'No Answer', value: 'noanswer', showOrder: 5, def: false},
  PHONE_NUMBER_CHANGE: {api_name: 'phonenumberchange', display: 'Phone Number Changed', value: 'phonenumberchange', showOrder: 6, def: false},
  INFO: {api_name: 'info', display: 'General Info', value: 'info', showOrder: 7, def: false},
  OPT_OUT: {api_name: 'optout', display: 'Do Not Call', value: 'optout', showOrder: 8, def: false},
  SEND_SMS: {api_name: 'sendsms', display: 'SMS Only', value: 'sendsms', showOrder: 9, def: false},
  WANTS_LIVE_AGENT: {api_name: 'wantsliveagent', display: 'Wants Live Agent', value: 'wantsliveagent', showOrder: 10, def: false},
  FAILED_LIVE_AGENT_TRANSFER: {api_name: 'failedliveagenttransfer', display: 'Transfer Failed', value: 'failedliveagenttransfer', showOrder: 11, def: false},
  TRANSFER_TO_HUMAN: {api_name: 'transfertohuman', display: 'Transferred to Human', value: 'transfertohuman', showOrder: 12, def: false},
  CALL_NOTE: {api_name: 'callnote', display: 'Call Note', value: 'callnote', showOrder: 13, def: false},
  INBOUND_CALL: {api_name: 'inbound_call', display: 'Inbound Call', value: 'inbound_call', showOrder: 14, def: false},
};

const MAP_AI_CALL_RESULT_API_TO_NAME = {};
const MAP_AI_CALL_RESULT_VALUE_TO_API = {};
// eslint-disable-next-line no-unused-vars
for (const [key, value] of Object.entries(AI_CALL_RESULTS)) {
  MAP_AI_CALL_RESULT_VALUE_TO_API[value.value] = value.api_name;
  MAP_AI_CALL_RESULT_API_TO_NAME[value.api_name] = value.value;
}

export {AI_CALL_RESULTS, MAP_AI_CALL_RESULT_API_TO_NAME, MAP_AI_CALL_RESULT_VALUE_TO_API};
